import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import bottomSheetMobileInfoWindowStyles from './bottomSheetMobileInfoWindowStyles'
import { setPolylineStyle } from '../../../utils/helpers'
import { setMarkerInfo } from '../../../sections/Map/redux/myMapsSlice'

export default function BottomSheetMobileInfoWindow({ setSheetConfig }) {
  const classes = bottomSheetMobileInfoWindowStyles()
  const [campusImage, setCampusImage] = React.useState(null)
  const dispatch = useDispatch()
  const { markerInfo, selectedCampus, datasetLayer } = useSelector(
    (s) => s.maps,
  )
  const chooseCampusImage = () => {
    let imageRef = null
    switch (selectedCampus) {
      case 'NEW BRUNSWICK':
        imageRef = {
          image: './assets/images/nb-campus.jpg',
          label: 'New Brunswick Campus',
        }
        break
      case 'NEWARK':
        imageRef = {
          image: './assets/images/nwk-campus.jpg',
          label: 'Newark Campus',
        }
        break
      case 'CAMDEN':
        imageRef = {
          image: './assets/images/cmd-campus.jpg',
          label: 'Camden Campus',
        }
        break
      default:
        imageRef = {
          image: './assets/images/nb-campus.jpg',
          label: 'New Brunswick Campus',
        }
    }
    setCampusImage(imageRef)
  }
  const backButtonFunc = {
    myFunction() {
      dispatch(setMarkerInfo({}))
      datasetLayer.style = setPolylineStyle
    },
  }
  React.useEffect(() => {
    const sheetConfig = {
      title: markerInfo.Lot,
      sheetColor: '',
      displayBackButton: false,
      displayCloseButton: true,
      backButtonFunc,
    }
    setSheetConfig(sheetConfig)
  }, [markerInfo])
  React.useEffect(() => {
    chooseCampusImage(selectedCampus)
  }, [selectedCampus])
  return (
    <div className={classes.mobileInfoWindowContainer}>
      <div className={classes.mapInfoCardContentContainer}>
        <div className={classes.campusContainer}>
          <Typography
            component="span"
            variant="body2"
            className={classes.campusImageText}
          >
            {campusImage?.label}
          </Typography>
        </div>
        <div className={classes.campusImageContainer}>
          {campusImage ? (
            <img
              src={campusImage?.image}
              alt="New Brunswick Campus"
              className={classes.campusImage}
            />
          ) : (
            <Skeleton width={250} height={154} />
          )}
        </div>
      </div>
      <div className={classes.mobileMarkerInfoContainer}>
        <Typography variant="subtitle1" className={classes.campusText}>
          {markerInfo.Lot}
        </Typography>
        <Typography variant="body2" className={classes.campusText}>
          {markerInfo['Address 1']}
        </Typography>
        <Typography variant="body2" className={classes.campusText}>
          {markerInfo['City Code']}
        </Typography>
        <Typography variant="body2" className={classes.campusText}>
          {markerInfo['MAP ID']}
        </Typography>
      </div>
    </div>
  )
}
